import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { RequestUrlUndefinedParamError } from "src/app/errors/request-url-undefined-param.error";

import { sntLog } from "src/app/common/logger";

const logger = sntLog("PreventUndefinedInterceptor");
@Injectable()
export class PreventUndefinedInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.toLowerCase().indexOf("/undefined/") >= 0 ||
      req.url.toLocaleLowerCase().indexOf("/null/") >= 0 ||
      req.url.endsWith("/undefined") ||
      req.url.endsWith("/null")
    ) {
      const error = new RequestUrlUndefinedParamError(
        "undefined or null found in request url!",
        req.url
      );

      logger.warn(`undefined or null found in request url: ${req.url}`);

      return throwError(() => error);
    }

    return next.handle(req);
  }
}
